<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">

      <v-col class="d-flex justify-end">
        <ButtonComp @click="showExportData" text-button="Generar reporte" normal-button icon-but="fas fa-file"
          class-color="success" />
        <v-spacer />
        <ButtonComp @click="addItem" text-button="Agregar" normal-button icon-but="fas fa-plus" />
        <ButtonComp @click="showDeleteItems" text-button="Eliminar" normal-button class-color="red"
          icon-but="fas fa-trash-alt" class-button="mx-2" />
      </v-col>
    </v-row>

    <!-- consultar -->
    <v-row dense>
      <v-col cols="12" md="2" sm="2">
        <v-menu v-model="menu_filtro_fecha_emision" :close-on-content-click="true" transition="scale-transition" offset-y
          max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="filtroFechaEmisionFormatted" label="Desde" readonly v-on="on"></v-text-field>
          </template>

          <v-date-picker v-model="filtro.fecha_emision" no-title @input="menu_filtro_fecha_emision = false"
            @change="getListaAsigOtraDeudas()">
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <v-menu v-model="menu_filtro_fecha_vencimiento" :close-on-content-click="true" transition="scale-transition"
          offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="filtroFechaVencimientoFormatted" label="Hasta" readonly v-on="on"></v-text-field>
          </template>

          <v-date-picker v-model="filtro.fecha_vencimiento" no-title @input="menu_filtro_fecha_vencimiento = false"
            @change="getListaAsigOtraDeudas()">
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3" sm="3">
        <AutocompleteComp text-label="Año" v-model="filtro.id_anio" :items="lista_filtro_anios" item-value="id"
          item-text="nom_anolectivo" @change="changeFiltroAnio(filtro.id_anio)" />
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Nivel" v-model="filtro.id_nivel" :items="lista_filtro_niveles" item-value="id"
          item-text="desc_nivel" @change="changeFiltroNivel(filtro.id_nivel)" />
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Grado" v-model="filtro.id_grado" :items="lista_filtro_grados" item-value="id"
          item-text="desc_grado" @change="changeFiltroGrado()" />
      </v-col>

      <v-col cols="12">

        <ComundataTablecomp :headers="DeudasTesoHeaders" :items="listItems" v-model="selectedItems" :loading="loading"
          itemkey="id_asig_movimiento_pago" whitSelect>

          <template v-slot:fecha_vencimiento="{ item }">{{ item.fecha_vencimiento | filtroFecha }}</template>
          <template v-slot:estado="{ item }">
            <v-chip small label dark
              :color="item.estado == 'PENDIENTE' ? 'btn_pendiente' : (item.estado == 'ANULADO' ? 'btn_anulado' : (item.estado == 'GENERADO' ? 'btn_generado' : ''))">
              {{ item.estado }}
            </v-chip>
          </template>

          <template v-slot:action_editar="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" editButton @click="editItem(item)"
              tooltipText="Editar registro de deuda" />
          </template>
        </ComundataTablecomp>
      </v-col>

    </v-row>




    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="showDialog" max-width="600px" :title="formTitle" @close-modal="showDialog = false">
        <template v-slot:body>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <AutocompleteComp text-label="Año" v-model="editedItem.id_anio" :items="lista_anios" :isDisable="!isNew"
                @change="changeAnio(editedItem.id_anio)" item-value="id" item-text="nom_anolectivo"
                :rules="validationRules.validateCampoList" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <AutocompleteComp text-label="Nivel" v-model="editedItem.id_nivel" :items="lista_niveles"
                :isDisable="!isNew" @change="changeNivel(editedItem.id_nivel)" item-value="id" item-text="desc_nivel"
                :rules="validationRules.validateCampoList" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <AutocompleteComp text-label="Grado" v-model="editedItem.id_grado" :items="lista_grados" :isDisable="!isNew"
                @change="changeGrado(editedItem.id_anio, editedItem.id_nivel, editedItem.id_grado)" item-value="id"
                item-text="desc_grado" :rules="validationRules.validateCampoList" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <AutocompleteComp text-label="Sección" v-model="editedItem.id_seccion" :items="lista_secciones"
                :isDisable="!isNew" @change="changeSeccion(editedItem.id_anio, editedItem.id_seccion)" item-value="id"
                item-text="nombre_seccion" :rules="validationRules.validateCampoList" />
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <AutocompleteComp text-label="Estudiante" v-model="editedItem.id_estudiante" :items="lista_estudiantes"
                :isDisable="!isNew" item-value="id" item-text="nombre_estudiante"
                :rules="validationRules.validateCampoList" />
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <textfieldComp textArea text-label="Concepto" type="text" v-model="editedItem.concepto"
                :rules="[rul.required, rul.min4, rul.max30]" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-menu v-model="menu_fecha_emision" :close-on-content-click="true" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="fechaEmisionFormatted" label="Fecha de emisión" readonly v-on="on"
                    :rules="[rul.required]"></v-text-field>
                </template>

                <v-date-picker v-model="editedItem.fecha_emision" no-title @input="menu_fecha_emision = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-menu v-model="menu_fecha_vencimiento" :close-on-content-click="true" transition="scale-transition"
                offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="fechaVencimientoFormatted" label="Fecha de vencimiento" readonly v-on="on"
                    :rules="[rul.required]"></v-text-field>
                </template>

                <v-date-picker v-model="editedItem.fecha_vencimiento" no-title @input="menu_fecha_vencimiento = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <AutocompleteComp text-label="Moneda" v-model="editedItem.id_moneda" :items="lista_monedas"
                item-value="id_moneda" item-text="nombre_moneda" :rules="validationRules.validateCampoList" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <textfieldComp text-label="Monto" type="number" v-model="editedItem.monto"
                :rules="validationRules.validateCampo" />
            </v-col>
          </v-row>

        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp :disabled="btnIsSaving" @click="saveItem(editedItem ? editedItem.id_asig_movimiento_pago : 0)"
            :textButton="isNew ? 'Guardar' : 'Guardar Cambios'" icon-but="fas fa-save" normalButton />
          <ButtonComp @click="showDialog = false" text-button="Cancelar" normal-button class-color="red"
            class-button="mx-2" />
        </template>
      </ComunDialogComp>

    </v-form>

    <confirm @aceptar="deleteItems" titleWindow="Eliminar registro" @cancelar="cancelDelete" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import { DeudasTesoHeaders } from '../../../../helpers/headersTable';
import { validationRules } from "../../../../helpers/validatorHelpers";

export default {
  components: {
    ComundataTablecomp,
    AutocompleteComp,
    ComunDialogComp,
    ButtonComp,
    textfieldComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    DeudasTesoHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      fecha_emision: null,
      fecha_vencimiento: null,
      id_anio: null,
      id_nivel: null,
      id_grado: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    menu_fecha_emision: false,
    menu_fecha_vencimiento: false,
    menu_filtro_fecha_emision: false,
    menu_filtro_fecha_vencimiento: false,
    listItems: [],
    lista_anios: [],
    lista_niveles: [],
    lista_grados: [],
    lista_secciones: [],
    lista_estudiantes: [],
    lista_monedas: [],
    lista_filtro_anios: [],
    lista_filtro_niveles: [],
    lista_filtro_grados: [],
    isNew: true,
    editedItem: {},
  }),

  computed: {

    validationRules() {
      return validationRules
    },

    formTitle() {
      return this.isNew ? "Registro de deuda" : "Editar registro de deuda";
    },

    fechaEmisionFormatted() {
      return this.formatDate(this.editedItem.fecha_emision);
    },

    fechaVencimientoFormatted() {
      return this.formatDate(this.editedItem.fecha_vencimiento);
    },

    filtroFechaEmisionFormatted() {
      return this.formatDate(this.filtro.fecha_emision);
    },

    filtroFechaVencimientoFormatted() {
      return this.formatDate(this.filtro.fecha_vencimiento);
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaAsigOtraDeudas();
    this.getListaAniosFiltro();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async showDeleteItems() {
      if (this.selectedItems.length > 0) {
        this.confirm.id = 0;
        this.confirm.title = "¿Está seguro de borrar los registros seleccionados?";
        this.confirm.active = true;
      }
    },

    cancelDelete() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    async limpiarForm() {
      this.editedItem = {};
      this.$refs.formDatos.resetValidation();
    },

    async changeFiltroAnio(id) {
      await this.getListaNivelesFiltro(id);
      await this.getListaAsigOtraDeudas();
    },

    async changeFiltroNivel(id) {
      await this.getListaGradosFiltro(id);
      await this.getListaAsigOtraDeudas();
    },

    async changeFiltroGrado() {
      await this.getListaAsigOtraDeudas();
    },

    async changeAnio(id) {
      await this.getListaNiveles(id);
    },

    async changeNivel(id) {
      await this.getListaGrados(id);
    },

    async changeGrado(id_anio, id_nivel, id_grado) {
      await this.getListaSecciones(id_anio, id_nivel, id_grado);
    },

    async changeSeccion(id_anio, id_seccion) {
      await this.getListaEstudiantes(id_anio, id_seccion);
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.btnIsSaving = false;
      this.isNew = true;
      await this.getListaAnios();
      await this.getListaMonedas();
      this.showDialog = true;
      this.limpiarForm();
    },

    //--------------EDITAR REGISTRO--------------
    async editItem(item) {
      console.log(item);
      this.btnIsSaving = false;
      this.isNew = false;
      await this.getListaAnios();
      await this.getListaNiveles(item.id_anio);
      await this.getListaGrados(item.id_nivel);
      await this.getListaSecciones(item.id_anio, item.id_nivel, item.id_grado);
      await this.getListaEstudiantes(item.id_anio, item.id_seccion);
      await this.getListaMonedas();
      await this.getAsigOtraDeudaById(item.id_asig_movimiento_pago);
      this.showDialog = true;
    },

    /// FILTROS
    getListaAniosFiltro() {
      axios
        .get("/administrativo/anoLectivo/estado/" + this.dataSession.id_colegio)
        .then((response) => {
          this.lista_filtro_anios = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaNivelesFiltro(id_anio) {
      this.lista_filtro_niveles = [];
      this.filtro.id_nivel = null;
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: id_anio,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_filtro_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGradosFiltro(id_nivel) {
      this.lista_filtro_grados = [];
      this.filtro.id_grado = null;
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_filtro_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    // FORMULARIO
    getListaAnios() {
      axios
        .get("/administrativo/anoLectivo/estado/" + this.dataSession.id_colegio)
        .then((response) => {
          this.lista_anios = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaNiveles(id_anio) {
      this.lista_niveles = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: id_anio,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGrados(id_nivel) {
      this.lista_grados = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaSecciones(id_anio, id_nivel, id_grado) {
      this.lista_secciones = [];
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: id_anio,
        id_nivel: id_nivel,
        id_grado: id_grado
      };
      axios
        .post("/tesoreria/common/seccion", params)
        .then((response) => {
          this.lista_secciones = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaEstudiantes(id_anio, id_seccion) {
      const params = { id_colegio: this.dataSession.id_colegio, id_anio: id_anio, id_seccion: id_seccion };
      axios
        .post("/tesoreria/common/estudiante", params)
        .then((response) => {
          this.lista_estudiantes = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaMonedas() {
      axios
        .get("/tesoreria/common/moneda")
        .then((response) => {
          this.lista_monedas = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    async getListaAsigOtraDeudas() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      await axios
        .post("/tesoreria/asignacion/otra_deuda/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    getAsigOtraDeudaById(id) {
      axios
        .get("/tesoreria/asignacion/otra_deuda/" + id)
        .then((response) => {
          console.log('editedItem jon', response.data);
          this.editedItem = response.data;
          this.editedItem.fecha_emision = this.editedItem.fecha_emision.slice(0, 10);
          this.editedItem.fecha_vencimiento = this.editedItem.fecha_vencimiento.slice(0, 10);
          console.log('editedItem jon', this.editedItem);
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
        });
    },

    async saveItem(id = 0) {
      console.log(id);
      if (this.$refs.formDatos.validate()) {
        this.btnIsSaving = true;
        try {
          const params = Object.assign({}, this.editedItem);
          params["user_id"] = this.dataSession.id;
          params["colegio_id"] = this.dataSession.id_colegio;
          console.log(params);
          if (this.isNew) {
            await axios.post("/tesoreria/asignacion/otra_deuda", params);
          } else {
            await axios.put("/tesoreria/asignacion/otra_deuda/" + id, params);
          }

          this.showDialog = false;
          this.setEnviarMens({ tipo: "S", mensaje: "¡Información creada con éxito!", tiempo: null });
          this.limpiarForm();
          this.getListaAsigOtraDeudas();
        }
        catch (error) {
          this.btnIsSaving = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    async deleteItems() {
      try {
        const params = this.selectedItems.map(x => ({ id_asig_movimiento_pago: x.id_asig_movimiento_pago }));
        console.log(params);

        let response = await axios.post("/tesoreria/asignacion/otra_deuda/delete_batch", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
          console.log(response);
        }
        else {
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.showDialog = false;
          this.cancelDelete();
          this.getListaAsigOtraDeudas();
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async showExportData() {
      try {
        const params = this.filtro;
        const anio_desc = this.lista_filtro_anios.filter(x => x.id == params.id_anio);
        params.anio_desc = anio_desc.length > 0 ? anio_desc[0]['nom_anolectivo'] : '';
        const nivel_desc = this.lista_filtro_niveles.filter(x => x.id == params.id_nivel);
        params.nivel_desc = nivel_desc.length > 0 ? nivel_desc[0]['desc_nivel'] : '';
        const grado_desc = this.lista_filtro_grados.filter(x => x.id == params.id_grado);
        params.grado_desc = grado_desc.length > 0 ? grado_desc[0]['desc_grado'] : '';
        params.id_colegio = this.dataSession.id_colegio;

        let response = await axios.post("/tesoreria/report/consulta/rpt_deudas_pendientes", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
        }
        else {
          let archivoADescargar = '';
          let dataResponse = response.data
          this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })
          this.generandoReporte = 0
          if (dataResponse.messageT == 'S') {
            archivoADescargar = dataResponse.fileToDownload;
            axios({
              url: '/tesoreria/report/bajarReporte/' + dataResponse.nameReport,
              method: 'GET',
              responseType: 'blob',
            }).then((response) => {
              this.setEnviarMens({ tipo: 'S', mensaje: 'Generando reporte', tiempo: 3000 })

              const url = window.URL.createObjectURL(new Blob([response.data]));
              console.log(response.data)
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', archivoADescargar);
              document.body.appendChild(link);
              link.click();
              link.remove()
              window.URL.revokeObjectURL(url);
            });
          }
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>